import {Totals, TotalsDataHook} from '../../../../../common/components/Totals/Totals';
import {Text} from '@wix/wix-ui-tpa/cssVars';
import {getTotal} from '../../../../../domain/utils/total.util';
import React, {useEffect} from 'react';
import {TotalsSectionDataHooks} from '../TotalsSection';
import {useControllerProps} from '../../../Widget/ControllerContext';
import {useLocaleKeys} from '../../../../../locale-keys/LocaleKeys';
import {classes} from '../TotalsSection.st.css';
import {TaxIncludedRow} from './TaxIncludedRow';
import {TotalUpdateSkeleton} from '../../TotalUpdateSkeleton';
import {useFedopsLogger, usePanorama} from '@wix/yoshi-flow-editor';
import {FedopsInteractions} from '../../../constants';

export const TotalRow = () => {
  const {cartSummary, isCartSummaryUpdating} = useControllerProps().checkoutStore;
  const fedops = useFedopsLogger();
  const panorama = usePanorama();

  const localeKeys = useLocaleKeys();

  useEffect(
    () => {
      fedops.interactionEnded(FedopsInteractions.SummaryLoaded);
      panorama.transaction(FedopsInteractions.SummaryLoaded).finish();
    },
    /* eslint-disable react-hooks/exhaustive-deps*/ []
  );

  return (
    <Totals.TotalsSection dataHook={TotalsSectionDataHooks.TotalSection}>
      <Totals.TotalsRow
        dataHook={TotalsSectionDataHooks.TotalRow}
        title={() => (
          <Text className={classes.totalRowText} data-hook={TotalsDataHook.TotalsRowTitle}>
            {localeKeys.checkout.order_summary.totals.total()}
          </Text>
        )}
        value={() =>
          isCartSummaryUpdating ? (
            <TotalUpdateSkeleton size="medium" />
          ) : (
            <Text data-hook={TotalsSectionDataHooks.TotalRowValue} className={classes.totalRowText}>
              {getTotal(cartSummary!)}
            </Text>
          )
        }
      />
      <TaxIncludedRow />
    </Totals.TotalsSection>
  );
};
